import React from 'react';
import s from '../OnboardingPage.module.scss';

export function FirstCustomizationStep({ classNames, changeWidgetName, handleText, changeWidgetColor, brandColor, changeWidgetShape }) {
    return (<><div style={{
        marginBottom: '3.5rem'
    }}>
        <div style={{
            marginBottom: '0.3rem'
        }} className={classNames([s.mediumTextSize, s.fontWeight600])}>Give your social shopping solution a name</div>
        <input onChange={changeWidgetName} type="text" style={{
            width: '616px',
            marginBottom: '0.4rem'
        }} className="form-control form-control-solid h-auto p-6 border-0 rounded-lg font-size-h4" name="firstname" placeholder="Shopping Party" defaultValue={handleText} />
        <span className={classNames([s.greyText, s.smallTextSize])} style={{
            letterSpacing: '0.1px'
        }}>The best names are easy to remember
        </span>
    </div>
        <div style={{
            marginBottom: '3.7rem'
        }}>
            <div style={{
                marginBottom: '0.4rem'
            }} className={classNames([s.mediumTextSize, s.fontWeight600])}>Choose your brand color</div>
            <input onChange={changeWidgetColor} type="color" defaultValue={brandColor} style={{
                width: '232px'
            }} className="form-control form-control-solid rounded-lg font-size-h6" name="color" />
        </div>
        <div className="form-group">
            <div style={{
                marginBottom: '0.9rem'
            }} className={classNames([s.mediumTextSize, s.fontWeight600])}>Select a design for your launcher</div>
            <div className="radio-list" onChange={changeWidgetShape}>
                <label className="radio radio-dark" style={{
                    fontSize: '1.23rem',
                    fontWeight: '500',
                    marginBottom: '1.2rem'
                }}>
                    <input defaultChecked="checked" type="radio" name="radios1" value="square" />
                    <span style={{
                        width: '24px',
                        height: '24px'
                    }}></span>
                    <div style={{
                        marginLeft: '0.7rem'
                    }}>
                        Handle
                    </div>
                </label>
                <label className="radio radio-dark" style={{
                    fontSize: '1.23rem',
                    fontWeight: '500'
                }}>
                    <input type="radio" name="radios1" value="circle" />
                    <span style={{
                        width: '24px',
                        height: '24px'
                    }}></span>
                    <div style={{
                        marginLeft: '0.7rem'
                    }}>
                        Button
                    </div>
                </label>
            </div>
        </div></>);
}
